import 'stylesheets/pages/community/style';
import SmoothScroll from 'smooth-scroll';

new SmoothScroll('a[data-scroll]', {
  easing: 'easeInOutCubic',
});
